import {useState} from 'react';

/**
 * Hook to provide a random online user count between 3000-5000
 * Replaces the socket-based online user functionality
 */
const useRandomOnlineUser = () => {
  // Generate random online user count between 3000-5000
  const [online] = useState(() => Math.floor(Math.random() * (5000 - 3000 + 1)) + 3000);

  return {
    online,
    // Keep the same interface as the original hook but make it a no-op
    initialSocket: () => {},
  };
};

export default useRandomOnlineUser;
